import searchSessionService from '@/js/common/Domain/Service/search/searchSession';

export default function getHrefToRedirectToTourPage(tourProducts, id) {
    const identity = tourProducts?.length ? tourProducts.at(0).get('id') : null;
    const urlParams = {
        sid: searchSessionService.getSearchId(),
        hsid: 0,
    };
    const hotelUrl = `/hotel/${id}/tourPage`;
    return `${hotelUrl}?${$.param({ identity })}#?${$.param(urlParams)}`;
}